require('./bootstrap');

window.toastr.options = {
    'closeButton': false,
    'debug': false,
    'newestOnTop': false,
    'progressBar': true,
    'positionClass': 'toast-top-center',
    'preventDuplicates': false,
    'showDuration': '200',
    'hideDuration': '200',
    'timeOut': '4000',
    'extendedTimeOut': '2000',
    'showEasing': 'linear',
    'hideEasing': 'linear',
    'showMethod': 'fadeIn',
    'hideMethod': 'fadeOut'
};

document.addEventListener('DOMContentLoaded', function () {

    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip({
        html: true
    });
    $('input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%' // optional
    });

    $('.datepicker').datepicker({
        format: 'yyyy-mm-dd',
        language: 'pl',
        autoclose: true,
        orientation: 'bottom',
        todayHighlight: true,
    });


    let PharmacySearch = new window.Bloodhound({
        datumTokenizer: window.Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: window.Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/search/pharmacy?q=%QUERY',
            wildcard: '%QUERY',
            rateLimitWait: 500
        }
    });

    let DrugSearch = new window.Bloodhound({
        datumTokenizer: window.Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: window.Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/search/drug?q=%QUERY',
            wildcard: '%QUERY',
            rateLimitWait: 500
        }
    });

    let DoctorSearch = new window.Bloodhound({
        datumTokenizer: window.Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: window.Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/search/doctor?q=%QUERY',
            wildcard: '%QUERY',
            rateLimitWait: 500
        }
    });

    /**
     * Autocomplete for pharmacies
     */
    let pharmacyAutocompleteInput = $('.pharmacies-autocomplete');
    let drugAutocompleteInput = $('.drugs-autocomplete');
    let doctorAutocompleteInput = $('.doctors-autocomplete');

    pharmacyAutocompleteInput.typeahead(null, {
        highlight: true,
        minLength: 3,
        limit: 50,
        name: 'pharmacies-list',
        display: 'pharmacies',
        source: PharmacySearch,
        classNames: {
            input: 'Typeahead-input',
            hint: 'Typeahead-hint',
            selectable: 'Typeahead-selectable'
        },
        templates: {
            empty: [
                '<div class="empty-message">',
                '<p class="alert alert-danger text-center"><strong>Brak wyników :( </strong><br>' +
                '</div>'
            ].join('\n'),
            suggestion: window.Handlebars.compile(
                '<div class="autocomplete-hint clearfix"> ' +
                '<strong>{{name}}</strong><br>' +
                '{{address}}, {{zipcode}} {{city}}, {{voivodeship}}<br>' +
                '<span class="text-muted">ID:{{id}} | {{email}}, {{phone}}</span>' +
                '</div>'),
            pending: [
                '<div class="autocomplete-hint clearfix text-center">',
                //'<img src="/media/loading.gif">',
                '<div class="">SZUKAM...</div>',
                '<br>',
                '</div>'
            ].join('\n'),
        }
    });
    
    drugAutocompleteInput.typeahead(null, {
        highlight: true,
        minLength: 3,
        limit: 50,
        name: 'drugs-list',
        display: 'drugs',
        source: DrugSearch,
        classNames: {
            input: 'Typeahead-input',
            hint: 'Typeahead-hint',
            selectable: 'Typeahead-selectable'
        },
        templates: {
            empty: [
                '<div class="empty-message">',
                '<p class="alert alert-danger text-center"><strong>Brak wyników :( </strong><br>' +
                '</div>'
            ].join('\n'),
            suggestion: window.Handlebars.compile(
                '<div class="autocomplete-hint clearfix"> ' +
                '<strong>{{name}}</strong> (dawka: {{dose}})<br></div>'),
            pending: [
                '<div class="autocomplete-hint clearfix text-center">',
                //'<img src="/media/loading.gif">',
                '<div class="">SZUKAM...</div>',
                '<br>',
                '</div>'
            ].join('\n'),
        }
    });
    
    doctorAutocompleteInput.typeahead(null, {
        highlight: true,
        minLength: 3,
        limit: 50,
        name: 'doctors-list',
        display: 'doctors',
        source: DoctorSearch,
        classNames: {
            input: 'Typeahead-input',
            hint: 'Typeahead-hint',
            selectable: 'Typeahead-selectable'
        },
        templates: {
            empty: [
                '<div class="empty-message">',
                '<p class="alert alert-danger text-center"><strong>Brak wyników :( </strong><br>' +
                '</div>'
            ].join('\n'),
            suggestion: window.Handlebars.compile(
                '<div class="autocomplete-hint clearfix"> ' +
                '<strong>{{name}}</strong><br></div>'),
            pending: [
                '<div class="autocomplete-hint clearfix text-center">',
                //'<img src="/media/loading.gif">',
                '<div class="">SZUKAM...</div>',
                '<br>',
                '</div>'
            ].join('\n'),
        }
    });

    pharmacyAutocompleteInput.bind('typeahead:select', function (ev, suggestion) {
        window.pharmacy_id_attach = suggestion.id;
        $('.btn-attach-pharmacy').removeClass('d-none');
        var source = $('#pharmacy-autocomplete-selected-template').html();
        var template = window.Handlebars.compile(source);
        var html = template(suggestion);
        $('#pharmacy-autocomplete-selected').html(html);
    });

    drugAutocompleteInput.bind('typeahead:select', function (ev, suggestion) {
        window.drug_id_attach = suggestion.id;
        $('.btn-attach-drug').removeClass('d-none');
        var source = $('#drug-autocomplete-selected-template').html();
        var template = window.Handlebars.compile(source);
        var html = template(suggestion);
        $('#drug-autocomplete-selected').html(html);
    });

    doctorAutocompleteInput.bind('typeahead:select', function (ev, suggestion) {
        window.doctor_id_attach = suggestion.id;
        $('.btn-attach-doctor').removeClass('d-none');
        var source = $('#doctor-autocomplete-selected-template').html();
        var template = window.Handlebars.compile(source);
        var html = template(suggestion);
        $('#doctor-autocomplete-selected').html(html);
    });

}, false);






// WEBPACK FOOTER //
// ./resources/js/app.js